// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__OK+L-","link":"HeaderSimple_link__IsSoT"};